import {Injectable} from '@angular/core';

import {HttpRepository} from './http.repository';
import {GlobalConfig} from '../configs/GlobalConfig';
import {AlertFeedback} from "../interfaces/rest/AlertFeedback";
import {AlertComment} from "../interfaces/rest/AlertComment";
import {UserSessionRepository} from "./user-session.repository";
import {Observable} from "rxjs";


@Injectable()
export class AlertFeedbackRepository {

    constructor(protected httpRepository: HttpRepository,
                protected userSessionRepository: UserSessionRepository) {

    }

    saveAlertComment(alertComment: AlertComment) {
      return this.httpRepository.post(GlobalConfig.dataApiEndpoints.alertData + '/comments', alertComment);

    }

    getAlertComments(alertInstanceId: string, alertRuleId: string) {
      return this.httpRepository.get(`${GlobalConfig.dataApiEndpoints.alertData}/comments?alertInstanceId=${alertInstanceId}&alertRuleId=${alertRuleId}`);

    }


    saveAlertFeedback(alertFeedback: AlertFeedback) {
      return this.httpRepository.post(GlobalConfig.dataApiEndpoints.alertData + '/feedback', alertFeedback);
    }


    getAlertFeedback(alertInstanceId: string, userEmail: string): Observable<AlertFeedback> {
      return this.httpRepository.get(`${GlobalConfig.dataApiEndpoints.alertData}/feedback?alertInstanceId=${alertInstanceId}&userEmail=${userEmail}`);
    }


}
